<template>
    <div class="profile">
        <div class="profile__content" v-loading="loading">
            <div v-if="!isMobile" class="profile__content--left">
                <div class="profile__avatar" :style="avatar" />
                <!-- <button // Не удалять до дальнейших указаний
                    v-if="canChat"
                    type="button"
                    class="blue-button"
                    @click="goToChatHandler"
                >
                    Написать
                </button> -->
                <div class="profile__coins-block" v-if="getCoinsData !== null">
                    <div class="profile__total-coins-text" @click="isShowHistory = true">
                        <IconCoins />
                        <div>{{ spaceInNumber(getCoinsData.totalCoins || 0) }}</div>
                        <IconClock />
                    </div>
                    <!-- Временно: маркет -->
                    <!-- <a href="https://market.rsv.ru" class="profile__link-market" target="_blank">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.0004 8V5C15.0004 2.79086 13.2095 1 11.0004 1C8.79123 1 7.00037 2.79086 7.00037 5V8M2.59237 9.35196L1.99237 15.752C1.82178 17.5717 1.73648 18.4815 2.03842 19.1843C2.30367 19.8016 2.76849 20.3121 3.35839 20.6338C4.0299 21 4.94374 21 6.77142 21H15.2293C17.057 21 17.9708 21 18.6423 20.6338C19.2322 20.3121 19.6971 19.8016 19.9623 19.1843C20.2643 18.4815 20.179 17.5717 20.0084 15.752L19.4084 9.35197C19.2643 7.81535 19.1923 7.04704 18.8467 6.46616C18.5424 5.95458 18.0927 5.54511 17.555 5.28984C16.9444 5 16.1727 5 14.6293 5L7.37142 5C5.82806 5 5.05638 5 4.44579 5.28984C3.90803 5.54511 3.45838 5.95458 3.15403 6.46616C2.80846 7.04704 2.73643 7.81534 2.59237 9.35196Z"
                                stroke="#69609f"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        В маркет
                    </a> -->
                    <a class="profile__link-how-get-coins" @click="isShowHowGetCoins = true">Как получить баллы?</a>
                </div>
            </div>
            <div v-if="user" class="profile__content--right">
                <div class="profile__user-id-and-rating">
                    <div class="profile__user-id">UserID: {{ user.userId }}</div>
                    <div class="profile__scores" v-if="getCoinsData !== null">
                        <div class="profile__total-scores">
                            <IconStarCircle class="profile__total-scores-icon" />
                            {{ getCoinsData.ratingPosition || '-' }}
                        </div>
                        <div class="profile__position">в рейтинге</div>

                        <router-link class="profile__link" :to="{ name: 'account-ratings' }">
                            <IconRatings />
                        </router-link>
                    </div>
                </div>

                <div class="profile__title">
                    {{ fullName }}
                </div>

                <div class="profile__qr-code" v-if="user">
                    <QrCode
                        :logo="user.avatar ? user.avatar.url : require('@/assets/images/account/placeHolder-m.png')"
                    />
                    <RefUser />
                </div>

                <div v-if="age" class="profile__text">
                    {{ age }}
                </div>

                <div v-if="user.address" class="profile__text">
                    {{ getUserAddress(user.address) }}
                </div>

                <div v-if="edit" class="profile__link">
                    <router-link :to="{ name: 'account-edit' }">Перейти к полному профилю</router-link>
                </div>

                <div v-if="user.activity && user.activity.length" class="profile__row">
                    <div class="profile__col--left">Сфера деятельности:</div>
                    <div class="profile__col--right">
                        {{ activities }}
                    </div>
                </div>

                <div v-if="user.about" class="profile__row">
                    <div class="profile__col--left">О себе:</div>
                    <div class="profile__col--right">
                        {{ user.about }}
                    </div>
                </div>

                <div v-if="showSocial" class="profile__row">
                    <div class="profile__col--left">Социальные сети:</div>
                    <div class="profile__col--right">
                        <SocialNetworks :netWorks="socialNetworks" />
                    </div>
                </div>
            </div>
        </div>
        <Dialog v-model="isShowHistory" overClose class="profile__dialog">
            <HistoryCoinsDialog />
        </Dialog>
        <Dialog v-model="isShowHowGetCoins" overClose class="profile__dialog">
            <HowGetCoinsDialog />
        </Dialog>
    </div>
</template>

<script>
import SocialNetworks from '@/components/account/userCard/SocialNetworks';
// import { send } from '@/tools/ws_chat';

import { mapActions, mapGetters } from 'vuex';

import IconStarCircle from '@/components/ratings/svg/IconStarCircle.vue';
import IconRatings from '@/components/ratings/svg/IconRatings.vue';
import IconCoins from '@/components/ratings/svg/IconCoins.vue';
import IconClock from '@/components/ratings/svg/IconClock.vue';
import HistoryCoinsDialog from '@/components/ratings/HistoryCoinsDialog.vue';
import HowGetCoinsDialog from '@/components/ratings/HowGetCoinsDialog.vue';
import Dialog from '@/components/UI/Dialog';
import spaceInNumber from '@/tools/spaceInNumber';
import QrCode from '@/components/UI/qr-code/QrCode.vue';
import RefUser from '@/components/UI/ref-user-link/RefUser.vue';
import str_counter from '../../tools/str_counter';

const declensionAge = str_counter('', 'год', 'года', 'лет');
const getters = ['isMobile', 'getUserRoles', 'getCoinsData'];
const usersGetters = ['getChatWithUserIsPrivate'];
const usersActions = [
    // 'loadChatWithUserIsPrivate', // Не удалять до дальнейших указаний
];
const dataGetters = ['getRegistryValueById'];
const dataActions = ['loadRegistryItems'];

export default {
    name: 'ParticipantProfile',

    components: {
        SocialNetworks,
        IconStarCircle,
        IconRatings,
        IconCoins,
        IconClock,
        HistoryCoinsDialog,
        HowGetCoinsDialog,
        Dialog,
        QrCode,
        RefUser,
    },

    props: {
        user: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: true,
            isShowHistory: false,
            isShowHowGetCoins: false,
        };
    },

    computed: {
        ...mapGetters(getters),
        ...mapGetters('newUsers', usersGetters),
        ...mapGetters('data', dataGetters),

        userId() {
            return this.$route.params.id || this.user.userId;
        },

        avatar() {
            return {
                'background-image':
                    this.user && this.user.avatar && this.user.avatar.url
                        ? `url('${this.user.avatar.url}')`
                        : `url('${require('@/assets/images/account/placeHolder-m.png')}')`,
            };
        },

        activities() {
            const data = this.user.activity.map((activity) => this.getRegistryValueById(activity));
            return data.join(', ');
        },

        fullName() {
            if (this.user) {
                const nameParts = [this.user.surname, this.user.name];
                return nameParts.join(' ');
            }
            return '';
        },

        age() {
            if (this.user && this.user.age) {
                return `${this.user.age} ${declensionAge(this.user.age)}`;
            }
            return '';
        },

        socialNetworks() {
            return this.user
                ? {
                      vk: this.user.vk,
                      ok: this.user.ok,
                      yt: this.user.yt,
                      telegram: this.user.telegram,
                      tiktok: this.user.tiktok,
                      zen: this.user.zen,
                      rutube: this.user.rutube,
                      yappy: this.user.yappy,
                      tenchat: this.user.tenchat,
                  }
                : null;
        },

        showSocial() {
            const keys = [
                'vk',
                'ok',
                'instagram',
                'fb',
                'yt',
                'telegram',
                'tiktok',
                'zen',
                'rutube',
                'yappy',
                'tenchat',
            ];
            return this.user ? keys.some((key) => this.user[key]) : false;
        },

        // canChat() { // Не удалять до дальнейших указаний
        //     const enableRoles = ['ROLE_ADMIN'];
        //     const isAdmin = enableRoles.some((el) =>
        //         this.getUserRoles.includes(el)
        //     );
        //     return isAdmin || !this.getChatWithUserIsPrivate;
        // },
    },

    async created() {
        if (this.userId) {
            // await this.loadChatWithUserIsPrivate({ // Не удалять до дальнейших указаний
            //     userId: this.userId,
            // });
        }
        await this.loadRegistryItems({ type: 'industries' });

        this.loading = false;
    },

    methods: {
        ...mapActions('newUsers', usersActions),
        ...mapActions('data', dataActions),

        // async goToChatHandler() { // Не удалять до дальнейших указаний
        //     send('create_room', { users_to_group: [this.userId] });
        //     await this.$router.push({ path: '/account/chat' });
        // },
        spaceInNumber: spaceInNumber,
        getUserAddress(address) {
            const country = address.data.country;
            const region = address.data.region_with_type;
            const city = address.data.city_with_type;
            const settlement = address.data.settlement_with_type;
            let parts = [country];
            if (region) {
                parts.push(region);
            }
            if (city && region !== city) {
                parts.push(city);
            }
            if (!city && settlement) {
                parts.push(settlement);
            }
            return parts.join(', ');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.profile {
    &__content {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: rem(14);
        line-height: rem(24);
        color: #2a2626;

        &--left {
            width: rem(214);
            margin: 0 rem(24) 0 0;
        }

        &--right {
            width: 100%;
        }
    }

    &__avatar {
        width: rem(214);
        height: rem(214);
        background: no-repeat center/contain;
        border-radius: rem(15);
    }

    &__user-id {
        margin-bottom: rem(10);
        font-weight: 400;
    }

    &__title {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        font-style: normal;
        font-weight: 600;
        font-size: rem(22);
        line-height: rem(32);
    }

    &__text {
        margin: rem(4) 0 0;
    }

    &__link {
        margin: rem(8) 0 rem(26);

        a {
            border-bottom: rem(1) solid #4663ab;
            font-weight: 600;
            color: #4663ab;
            cursor: pointer;
        }
    }

    &__row {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        margin: rem(24) 0 0;
    }

    &__col {
        &--left {
            flex: 0 0 rem(140);
            margin-right: rem(12);
            font-weight: 600;
            color: #98a0a9;
        }

        &--right {
            word-break: break-word;
        }
    }

    &__user-id-and-rating {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: 'Montserrat', sans-serif;
    }

    &__user-id {
        color: #98a0a9;
        margin-bottom: 0;
    }

    &__scores {
        display: flex;
        align-items: center;
        gap: mrem(8);

        margin-left: auto;
        margin-bottom: mrem(16);

        @include on-desktop {
            gap: rem(8);
            padding-top: 0;
            margin-bottom: 0;
        }
    }

    &__total-scores-icon {
        width: mrem(20);
        height: mrem(20);

        @include on-desktop {
            width: rem(20);
            height: rem(20);
        }
    }

    &__position {
        font-size: mrem(14);
        line-height: mrem(20);
        font-weight: 500;
        color: #2a2626;

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(24);
        }
    }

    &__coins-block {
        padding-bottom: mrem(24);
        border-bottom: mrem(1) solid #d6e0ea;
        margin-bottom: mrem(25);
        display: flex;
        flex-direction: column;
        align-items: center;

        @include on-desktop {
            padding-bottom: 0;
            border: none;
            margin-bottom: 0;
        }
    }

    &__total-scores {
        display: flex;
        align-items: center;
        gap: mrem(10);

        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(14);

        line-height: mrem(20);
        text-align: center;
        color: #2a2626;

        @include on-desktop {
            gap: rem(10);
            font-size: rem(16);
            line-height: rem(24);
            text-align: right;
            justify-content: flex-end;
        }
    }

    &__link {
        margin-left: auto;

        @include on-desktop {
            margin-bottom: 0;
        }

        svg {
            width: mrem(48);
            height: mrem(48);

            @include on-desktop {
                width: rem(48);
                height: rem(48);
            }
        }
    }

    &__total-coins-text {
        display: flex;
        align-items: center;
        gap: mrem(8);
        font-family: 'Montserrat', sans-serif;
        font-weight: 700;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #2a2626;
        cursor: pointer;
        margin-top: mrem(10);

        div {
            flex-shrink: 0;
        }

        svg {
            width: mrem(24);
            height: mrem(24);
            flex-shrink: 0;
        }

        @include on-desktop {
            gap: rem(8);
            font-size: rem(16);
            line-height: rem(24);
            width: rem(200);
            margin-top: rem(20);
            justify-content: center;

            svg {
                width: rem(24);
                height: rem(24);
                flex-shrink: 0;
            }
        }
    }

    &__link-market {
        border-radius: mrem(10);
        padding: mrem(10) mrem(20);
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: mrem(10);
        color: black;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        margin-top: mrem(20);
        position: relative;
        z-index: 1;
        cursor: pointer;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, #e0f7f6 0%, #ede5fb 100%);
            z-index: -1;
            border-radius: mrem(10);

            @include on-desktop {
                border-radius: rem(10);
            }
        }

        @include on-desktop {
            border-radius: rem(10);
            padding: rem(9) rem(20);
            height: rem(42);
            font-size: rem(14);
            line-height: rem(20);
            margin-top: rem(20);
            width: 100%;
            gap: rem(10);

            svg {
                width: rem(22);
            }
        }
    }

    &__link-how-get-coins {
        color: #69609f;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        text-decoration: underline;
        margin-top: mrem(16);
        display: inline-block;
        cursor: pointer;

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
            margin-top: rem(20);
        }
    }

    &__dialog {
        padding: 0;
        z-index: 999999999999999999;

        ::v-deep div.dialog {
            width: 100vw;
            max-height: 100dvh;
            max-height: 100vh;
            height: 100vh;
            height: 100dvh;
            overflow: auto;
            border-radius: 0;

            @include on-desktop {
                width: rem(680);
                height: auto;
                max-height: rem(740);
                border-radius: rem(10);
                padding-right: rem(10) !important;
            }
        }
    }

    &__qr-code {
        display: flex;
        gap: urem(10);
    }
}
</style>
